import {Injectable} from '@angular/core';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import {finalize} from 'rxjs/internal/operators';

import {BaseService} from './base.service';

@Injectable({providedIn: 'root'})
export class BaseDatasourceService<T> implements DataSource<T> {

    _moduleSubject = new BehaviorSubject<T[]>([]);
    _loadingSubject = new BehaviorSubject<boolean>(false);
    _totalElementSubject = new BehaviorSubject<T[]>([]);

    public loading = this._loadingSubject.asObservable();
    public dataCount = this._moduleSubject.asObservable();
    public numberOfElements = this._moduleSubject.asObservable();
    public totalAmount = 0;
    public syncedCount = 0;
    public notSyncedCount = 0;
    public isEmpty = true;
    approved: number;
    pending: number;
    rejected: number;
    others: any;
    totalElements: number;
    totalOrderAmount: number;
    totalProductCount: number;
    totalOrderQuantity: number;
    totalChemistCount: number;
    totalOrderCount: number;
    totalCount: number;
    userCount: number;
    footer: any;

    constructor(private service: BaseService) {
    }

    connect(pCollectionViewer: CollectionViewer): Observable<T[]> {
        return this._moduleSubject.asObservable();
    }

    disconnect(pCollectionViewer: CollectionViewer): void {
        this._moduleSubject.complete();
        this._loadingSubject.complete();
    }

    get data(): any {
        return this._moduleSubject.value.length ? this._moduleSubject.value : [];
    }

    get totalElementsCount(): any {
        return this._totalElementSubject.value || 0;
    }

    fetchRemoteData(pEndpoint: string, pFilters: object): void {
        this._loadingSubject.next(true);
        this.service.postData(pEndpoint, pFilters)
            .pipe(
                finalize(() => this._loadingSubject.next(false))
            )
            .subscribe(response => {
                this._moduleSubject.next(response['Data']['content']);
                this.dataCount = response['Data']['totalElements'] || response['Data']['content'].length;
                this.numberOfElements = response['Data']['numberOfElements'];
                this.totalAmount = response['Data']['TotalAmount'] || 0;
                this.syncedCount = response['Data']['SyncedCount'] || 0;


                this.totalOrderAmount = response['Data']['TotalOrderAmount'] || 0;
                this.totalOrderCount = response['Data']['TotalOrderCount'] || 0;
                this.totalOrderQuantity = response['Data']['TotalOrderQuantity'] || 0;
                this.totalProductCount = response['Data']['TotalProductCount'] || 0;
                this.totalChemistCount = response['Data']['TotalChemistCount'] || 0;
                this.userCount = response['Data']['UserCount'] || 0;

                this.isEmpty = response['Data']['empty'];
                this.others = response['Data']['Others'];
                if (response['Data']['Others']) {
                    this.approved = response['Data']['Others'].TotalApproved;
                    this.pending = response['Data']['Others'].TotalPending;
                    this.rejected = response['Data']['Others'].TotalRejected;
                    this.footer = response['Data']['Others'].Footer;
                    this.totalCount = response['Data']['Others'].TotalCount;
                }

                this.notSyncedCount = response['Data']['NotSyncedCount'] || 0;
            });
    }

    fetchGetData(pEndpoint: string, pFilters: object): void {
        this._loadingSubject.next(true);
        this.service.getData(pEndpoint, pFilters)
            .pipe(
                finalize(() => this._loadingSubject.next(false))
            )
            .subscribe(response => {
                this._moduleSubject.next(response['Data']['content']);
                this.dataCount = response['Data']['totalElements'] || response['Data']['content'].length;
                this.numberOfElements = response['Data']['numberOfElements'];
                this.totalAmount = response['Data']['TotalAmount'] || 0;
                this.syncedCount = response['Data']['SyncedCount'] || 0;


                this.totalOrderAmount = response['Data']['TotalOrderAmount'] || 0;
                this.totalOrderCount = response['Data']['TotalOrderCount'] || 0;
                this.totalOrderQuantity = response['Data']['TotalOrderQuantity'] || 0;
                this.totalProductCount = response['Data']['TotalProductCount'] || 0;
                this.totalChemistCount = response['Data']['TotalChemistCount'] || 0;
                this.userCount = response['Data']['UserCount'] || 0;

                this.isEmpty = response['Data']['empty'];
                this.others = response['Data']['Others'];
                if (response['Data']['Others']) {
                    this.approved = response['Data']['Others'].TotalApproved;
                    this.pending = response['Data']['Others'].TotalPending;
                    this.rejected = response['Data']['Others'].TotalRejected;
                    this.footer = response['Data']['Others'].Footer;
                    this.totalCount = response['Data']['Others'].TotalCount;
                }

                this.notSyncedCount = response['Data']['NotSyncedCount'] || 0;
            });
    }

    fetchGetDataForMicroservice(pEndpoint: string, pFilters: object): void {
        this._loadingSubject.next(true);
        this.service.getDataForMicroService(pEndpoint, pFilters)
            .pipe(
                finalize(() => this._loadingSubject.next(false))
            )
            .subscribe(response => {
                this._moduleSubject.next(response['Data']['content']);
                this.dataCount = response['Data']['totalElements'] || response['Data']['content'].length;
                this.numberOfElements = response['Data']['numberOfElements'] || response['Data']['content'].length;
            });
    }

    fetchPostDataForMicroservice(pEndpoint: string, pFilters: object): void {
        this._loadingSubject.next(true);
        this.service.postDataForMicroService(pEndpoint, pFilters)
            .pipe(
                finalize(() => this._loadingSubject.next(false))
            )
            .subscribe(response => {
                this._moduleSubject.next(response['data']['content']);
                this._totalElementSubject.next(response['data']['totalElements']);
                this.dataCount = response['data']['totalElements'] || response['data']['content'].length;
                this.numberOfElements = response['data']['numberOfElements'] || response['data']['content'].length;
            });
    }
    setLocalData(pDataArray: any, numberOfTotalElements: any, numberOfCurrentElements?: any): void {
        this._moduleSubject.next(pDataArray);
        this.dataCount = numberOfTotalElements;
        this.numberOfElements = numberOfCurrentElements;
    }
}
